import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { ProductMeasureBody } from "types/api/productMeasure";

function useProductMeasureApi() {
    const { del, post, put } = useHttpManaged();
    const createProductMeasure = React.useCallback((body: ProductMeasureBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, ProductMeasureBody, ResponseWithId>({
            url: "/product-measure",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateProductMeasure = React.useCallback((pathParams: PathParamsWithId, body: ProductMeasureBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, ProductMeasureBody, null>({
            url: "/product-measure/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteProductMeasure = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/product-measure/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        createProductMeasure,
        updateProductMeasure,
        deleteProductMeasure
    };
}

export default useProductMeasureApi;